import React from "react";
import PropTypes from "prop-types";

/**
 * Edit boolean checkbox cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */

export const readMultiCell = ({ getColumns, isValueChanged = () => false }) => {
  const ReadMultiCell = (props) => {
    const { dataItem, field, tdProps } = props;

    const value = dataItem[field] === null ? [] : dataItem[field];
    const splitField = field.split(".")[0];
    const item = getColumns().find((item) => item.field === splitField);

    return (
      <td
        {...tdProps}
      // colSpan={colSpan}
      // className={className}
      // style={style}
      // role="gridcell"
      // aria-colindex={(columnIndex || 0) - (level || 0) + 1}
      // aria-selected={false}
      // tabIndex="0"
      >
        {value && value.map((x) => x[item.textField]).join(", ")}
      </td>
    );

  };

  ReadMultiCell.propTypes = {
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func,
  };
  return ReadMultiCell;
};
